import { useEffect, useState } from "react";
import { useNetwork } from "wagmi";

export function useSupportedNetwork() {
  const { chain, chains } = useNetwork();
  const [isSupportedNetwork, setIsSupportedNetwork] = useState(false);

  useEffect(() => {
    let supported = false;
    if (chain && chains && chains.length > 0) {
      for (let idx in chains) {
        let c = chains[idx];
        if (c.id === chain.id) {
          supported = true;
          break;
        }
      }
    }

    setIsSupportedNetwork(supported);
  }, [chain, chains]);

  return { isSupportedNetwork, chain, chains };
}
